/**
 * Section Animations
 * Automatically applies fade-in animations to all sections when they enter the viewport
 */

(function() {
  'use strict';

  // Selector for sections that should be animated
  const SECTION_SELECTORS = [
    '.hero-section',
    '.brands-logos',
    '.product-cards-carousel',
    '.stats-banner',
    '.simple-banner',
    '.reviews-section',
    '.features-grid',
    '.bestsellers-section',
    '.hero-features',
    '.scroll-text',
    'section[class*="section-"]',
    '[id^="shopify-section-"]'
  ];

  // Configuration
  const CONFIG = {
    // Keep the threshold low enough for tall sections (for example, collection grids).
    // A 15% threshold can be physically unreachable when the section is taller than
    // the viewport, leaving the whole section permanently hidden at opacity: 0.
    threshold: 0.01,
    rootMargin: '0px 0px -50px 0px', // Start animation slightly before section enters viewport
    animationClass: 'section-fade-in',
    animateClass: 'animate'
  };

  /**
   * Initialize animations for all sections
   */
  function initSectionAnimations() {
    // Find all sections that should be animated
    const sections = [];
    SECTION_SELECTORS.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        // Skip header sections
        if (el.classList.contains('section-header') || 
            el.classList.contains('i-section') ||
            el.classList.contains('i-header-container')) {
          return;
        }
        // Skip features-scroll (tiene su propia animación de scroll)
        if (el.classList.contains('features-scroll')) {
          return;
        }
        // Skip if already processed or if it's a child of another section
        if (!el.classList.contains(CONFIG.animationClass) && 
            !el.closest(`.${CONFIG.animationClass}`)) {
          sections.push(el);
        }
      });
    });

    if (sections.length === 0) return;

    // Add animation class to all sections
    sections.forEach((section, index) => {
      section.classList.add(CONFIG.animationClass);
      
      // Add staggered delay for visual effect (optional)
      if (index > 0 && index % 2 === 0) {
        section.classList.add('section-fade-in-delay-1');
      }
    });

    // Create Intersection Observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(CONFIG.animateClass);
          // Unobserve after animation to improve performance
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: CONFIG.threshold,
      rootMargin: CONFIG.rootMargin
    });

    // Observe all sections
    sections.forEach(section => {
      observer.observe(section);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSectionAnimations);
  } else {
    initSectionAnimations();
  }

  // Re-initialize when Shopify theme editor makes changes
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initSectionAnimations);
    document.addEventListener('shopify:section:reorder', initSectionAnimations);
  }
})();
